import React from 'react'
import { Form } from 'react-bootstrap'
import { ServiceDataModel, EmptyServiceData } from '../OrderModels'
import SelectServiceTogglePanel from './SelectServiceTogglePanel'
import SelectService, { SelectServiceProps, SelectServiceState } from './SelectService'
import { ServiceTypeCode } from "../../../api/Administration/Model/ServiceType"
import { IsServiceActive, ServiceByCode } from "../../../api/Administration/Model/Service"
import RegulatoryModeControl from '../RegulatoryModeControl'
import { ServiceCode } from '../../../api/LookupCodes/ServiceCode'

export default class SelectPhysicalExam extends SelectService<SelectServiceProps, SelectServiceState> {
  defaultService: ServiceDataModel = {...EmptyServiceData, serviceTypeCode: ServiceTypeCode.Physical, serviceCode: ServiceCode.None}
  state: SelectServiceState = { ...this.defaultService }

  setInitialState = () => this.setState({ ...this.defaultService })

  onChangeTestType = (e: React.ChangeEvent<HTMLInputElement>) => {
    const orderableServices = this.props.orderableServices;
    const serviceCode = e.target.value as ServiceCode;
    const service = ServiceByCode(orderableServices, serviceCode);
    this.setState(
      {
        serviceCode: serviceCode,
        isDOT: service.DOT,
        isMarketplace: service.Marketplace
      })
  }
  onServiceAdd = () => {
    this.props.onAdd(this.state as ServiceDataModel)
    this.setInitialState()
  }

  onPanelClose = () => {
    // Clear all entered values
    this.setInitialState()
  }

  isValid = (data: ServiceDataModel): boolean => {
    if(this.isAllServicesDisabled || this.props.denyAddService){
      return false
    }
    return typeof data.isDOT === "boolean" && (data.isDOT !== true || this.state.isValidMode)
  }
  render() {
    const { disabled } = this.props
    const orderableServiceType = this.props.orderableServiceType;

    const marketplaceServicesCount = this.props.marketplaceServicesCount;
    const notMarketplaceServicesCount = this.props.notMarketplaceServicesCount;

    const canAddMarketplace = notMarketplaceServicesCount === 0;
    const canAddNotMarketplace = marketplaceServicesCount === 0;


    return (
      <SelectServiceTogglePanel title={orderableServiceType.ServiceTypeName || "PHYSICAL EXAM"}
                                data={this.state as ServiceDataModel}
                                collapsibleId='PhysicalExamCollapsePanel'
                                disabled={disabled}
                                onSubmit={this.onServiceAdd}
                                onValidate={this.isValid}
                                onClose={this.onPanelClose}>
        <Form.Row className="px-2">
          {this.getServicesComponents()}
        </Form.Row>
        {this.state.isDOT && <RegulatoryModeControl
          defaults={this.props.defaults}
          regulatoryModeID={this.props.regulatoryModeID}
          employeeCategoryID={this.props.employeeCategoryID}
          onChange={(isValid, mode, cat) => this.setState({ isValidMode: isValid, regulatoryModeObj: mode, categoryObj: cat })}
        />}
      </SelectServiceTogglePanel>
    )
  }

  getServicesComponents() {
    const { disabled, canAddDOT, canAddNonDOT } = this.props
    const orderableServiceType = this.props.orderableServiceType;
    const orderableServices = this.props.orderableServices;
    const orderableAccountServices = this.props.orderableAccountServices
    const marketplaceServicesCount = this.props.marketplaceServicesCount;
    const notMarketplaceServicesCount = this.props.notMarketplaceServicesCount;
    const canAddMarketplace = notMarketplaceServicesCount === 0;
    const canAddNotMarketplace = marketplaceServicesCount === 0;

    let servicesComponents = [];
    this.isAllServicesDisabled = true;
    for (let i = 0; i < orderableServices.length; i++) {
      const orderableService = orderableServices[i];
      const serviceActive = IsServiceActive(orderableService, orderableAccountServices);
      const item_id = orderableService.DOT ? "regulated-physical-exam" : "non-regulated-physical-exam";
      //const item_value = orderableService.DOT ? "regulated" : "non-dot";
      const item_value = orderableService.FFServiceCode;

      const item_disabled = !serviceActive
        || (orderableService.DOT && !canAddDOT)
        || (!orderableService.DOT && !canAddNonDOT)
        || (orderableService.Marketplace && !canAddMarketplace)
        || (!orderableService.Marketplace && !canAddNotMarketplace)

        if(!item_disabled){
          this.isAllServicesDisabled = false;
        }


      const item_checked = (canAddDOT && this.state.isDOT === true && orderableService.DOT) || (canAddNonDOT && this.state.isDOT === false && !orderableService.DOT)
      const serviceComponent = <Form.Check label={orderableService.ServiceDescription}
        id={item_id}
        key={item_id}
        type="radio"
        name="testType"
        className="font-weight-bold abc-radio"
        disabled={item_disabled}
        value={item_value}
        onChange={this.onChangeTestType}
        checked={item_checked} />
      servicesComponents.push(serviceComponent)
    }
    return <Form.Group className={this.state.serviceCode ? "section-border p-2" : "invalid-section-border p-2"}>{servicesComponents}</Form.Group>
  }
}
